import { getAuth } from "firebase/auth";
import { getAuthCentral } from "../../config/FirebaseConfig";
import { getFirestore, doc, getDoc } from "firebase/firestore";
import { checkDB } from "../../models/DataFunctions.js";
import addLogDocument from "../addLogDocument.js"; // Assuming a custom log function

const sendPasswordResetEmailNoAuth = async (email, prefix) => {
  // Define the endpoint URL
  const url = prefix + "auth/send-password-reset-email-no-auth/" + email;

  // Define the request body
  const body = {};

  // Define headers
  const headers = {
    "Content-Type": "application/json",
  };

  try {
    // Make the POST request using the Fetch API
    const response = await fetch(url, {
      method: "POST",
      headers: headers,
      body: JSON.stringify(body), // Encode the body as JSON
    });

    // Check if the request was successful
    if (response.ok) {
      return ""; // Success response
    } else {
      console.error(`Failed to send password reset email: ${response.status}`);
      return "";
    }
  } catch (error) {
    // Handle exceptions
    console.error(`Exception occurred: ${error.message}`);
    return "";
  }
};

export default sendPasswordResetEmailNoAuth;
